module.exports = __webpack_public_path__ + "static/media/menu_icon.b1eb1eb6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu_icon.svg
// module id = 75
// module chunks = 0